import utils from './services/utils';
import hproLog from './services/log';
import webPushClient from './services/webpush-client';
import notificationAPI from './services/notification';

var clientInstance = webPushClient();

window.hproWebPush = window.hproWebPush || [];

if (notificationAPI.isSupported() && clientInstance) {
    // hproLog.log('WebPush API or Notification API are supported');

    var syncMessages = [];

    var pushCommand = function (item) {
        var propertyName = null;
        // first element is method name
        // second element is method name
        if (utils.isFunction(item)) {
            return item();
        }
        else {
            var propertyName = item.shift();

            clientInstance[propertyName].apply(null, item);

            return clientInstance[propertyName].apply(null, item);
        }

        hproLog.error('Unknown command');
    };

    hproWebPush.push = pushCommand;
    hproWebPush.isSupported = notificationAPI.isSupported;
    hproWebPush.getPermission = notificationAPI.getPermission;
    hproWebPush.init = clientInstance.init;
    hproWebPush.register = clientInstance.register;
    hproWebPush.isSubscribed = clientInstance.isSubscribed;
    hproWebPush.subscribe = clientInstance.subscribe;
    hproWebPush.update = clientInstance.update;
    hproWebPush.unsubscribe = clientInstance.unsubscribe;
    hproWebPush.permit = clientInstance.permit;
    /* webPushAPI.restore = clientInstance.restore;
    webPushAPI.test = clientInstance.test; */

    if (hproWebPush
        && hproWebPush.length !== undefined
    ) {
        for (var i = 0; i < hproWebPush.length; i++) {
            hproWebPush.push(hproWebPush[i]);
        }
    }

    /* hproLog.enable(); */
}

export default hproWebPush;


//////////////////
// WEBPACK FOOTER
// ./src/sdk.js
// module id = 12
// module chunks = 0